var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isEmptyData
    ? _c("v-client-table", {
        staticClass: "w-100 vue-custom-table no-pagination text-center",
        attrs: {
          data: _vm.lenderSubmissions,
          columns: _vm.table.columns,
          options: _vm.options,
          name: "submissionHistoryTable",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "date",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", [
                    _vm._v(_vm._s(_vm._f("formatDate")(row.createdAt))),
                  ]),
                ]
              },
            },
            {
              key: "type",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", { staticClass: "capitalize" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("application-form." + row.dealType)) +
                        "\n    "
                    ),
                  ]),
                ]
              },
            },
            {
              key: "lender",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", { staticClass: "capitalize" }, [
                    _vm._v("\n      " + _vm._s(row.lenderName) + "\n    "),
                  ]),
                ]
              },
            },
            {
              key: "status",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c(
                      "div",
                      { staticClass: "col-5 text-center" },
                      [
                        _c(
                          "badge",
                          {
                            staticClass:
                              "capitalize text-decoration-line-through m-0",
                            attrs: { type: "gray" },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "application.filogixStatus." + row.status
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-2 text-center" },
                      [_c("icon", { attrs: { name: "long-arrow-right" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-5 text-center" },
                      [
                        _c(
                          "badge",
                          {
                            staticClass: "capitalize m-0",
                            attrs: { type: _vm.getBadgeType(row.status) },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "application.filogixStatus." +
                                      _vm.getNewStatus(row.status)
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              },
            },
            {
              key: "insurance",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", { staticClass: "capitalize" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("formatMoneyValue")(
                            _vm.checkForLenderResponseInsurance(row)
                          )
                        ) +
                        "\n    "
                    ),
                  ]),
                ]
              },
            },
            {
              key: "mortgage",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", { staticClass: "capitalize" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("application-form." + row.mortgageType)) +
                        "\n    "
                    ),
                  ]),
                ]
              },
            },
            {
              key: "loanAmount",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", { staticClass: "capitalize" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("formatMoneyValue")(
                            _vm.checkForLenderResponseMortgage(row)
                          )
                        ) +
                        "\n    "
                    ),
                  ]),
                ]
              },
            },
            {
              key: "actions",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "div",
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mt-1",
                          attrs: { size: "sm", variant: "white" },
                          on: {
                            click: function ($event) {
                              return _vm.applicationPdf(row)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$tc("global.doorr.application", 1)) +
                              "\n      "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip",
                              value: {
                                title: !row.lenderNote
                                  ? _vm.$t(
                                      "direct-to-lender.lenderSubmit.emptyNotes"
                                    )
                                  : "",
                              },
                              expression:
                                "{\n          title: !row.lenderNote\n            ? $t('direct-to-lender.lenderSubmit.emptyNotes')\n            : ''\n        }",
                            },
                          ],
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-1",
                              attrs: {
                                size: "sm",
                                variant: "white",
                                disabled: !row.lenderNote,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.lenderNote(row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "direct-to-lender.lenderSubmit.lenderNote"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ],
          null,
          false,
          1060278032
        ),
      })
    : _c(
        "no-results",
        {
          attrs: {
            "img-src": require("@Shared/@Assets/img/application-missing.png"),
          },
        },
        [
          _vm._v(
            "\n  " +
              _vm._s(_vm.$t("direct-to-lender.lenderSubmit.emptySubmissions")) +
              "\n"
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }